function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CircularProgress } from "@material-ui/core";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { getChannelHistory, setCurrentChannel } from "@common/actions";
import { getLiveChannels } from "@common/actions/live-channels";
import { getToday, replaceWith, secondsToMilliseconds } from "@common/services/helpers";
import { CHANNEL_UPCOMING_PAGE_SIZE, LIST_LEVEL_ONE, TOOLTIP_SHOW_DELAY } from "@config/constants";
import { isEmpty } from "lodash";
import ActiveTitle from "@common/components/ActiveTitle";
import ChannelLogo from "@common/components/ChannelLogo";
import protect from "@common/components/HoC/protect";
import withParentalLock from "@common/components/HoC/withParentalLock";
import LoadProgressBar from "@common/components/LoadProgressBar";
import ShowsSlider from "@common/components/shows-slider/ShowsSlider";
import { SLIDER_BIG } from "@common/services/responsive";
var ChannelHistory = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ChannelHistory, PureComponent);
    var _super = _create_super(ChannelHistory);
    function ChannelHistory(props) {
        _class_call_check(this, ChannelHistory);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "renderUpcomingSlider", function() {
            var _this_props = _this.props, currentChannel = _this_props.currentChannel, history = _this_props.history, i18n = _this_props.i18n, logos = _this_props.logos, match = _this_props.match;
            var isDataLoaded = _this.state.isDataLoaded;
            if (!isDataLoaded) {
                return null;
            }
            var todayDate = getToday();
            var todayTimestamp = todayDate.getTime();
            var todayEpgs = currentChannel.epgs[todayTimestamp] || [];
            // Here 'todayDate' is mutated!
            var tomorrowDate = new Date(todayDate.setDate(todayDate.getDate() + 1));
            var tomorrowTimestamp = tomorrowDate.getTime();
            var tomorrowEpgs = currentChannel.epgs[tomorrowTimestamp] || [];
            var upcomingShows = _to_consumable_array(tomorrowEpgs).concat(_to_consumable_array(todayEpgs)).reverse();
            var showsToRender = [];
            for(var i = 0; i < upcomingShows.length; i++){
                if (upcomingShows[i].now) {
                    showsToRender = upcomingShows.slice(i, i + CHANNEL_UPCOMING_PAGE_SIZE);
                }
            }
            var isTodayEpgsRequestPending = currentChannel.epgs.isTodayEpgsRequestPending;
            if (upcomingShows.length > 0 || isTodayEpgsRequestPending) {
                _this.setState({
                    showLoader: false
                });
            }
            return upcomingShows.length > 0 || isTodayEpgsRequestPending ? showsToRender.length > 0 ? /*#__PURE__*/ _jsx(ShowsSlider, {
                infinite: false,
                channelsLogos: logos,
                shows: showsToRender,
                history: history,
                i18n: i18n,
                hasLogo: false,
                hasTitle: true,
                category: {
                    id: match.params.channel
                },
                hasStaticTitle: true,
                showCategories: true,
                staticLinkTitle: i18n.common.upcoming,
                level: LIST_LEVEL_ONE,
                responsiveKey: SLIDER_BIG,
                isCardBig: true
            }) : null : /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(ActiveTitle, {
                        hasStaticTitle: true,
                        staticLinkTitle: i18n.common.upcoming
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "no-shows-container",
                        children: i18n.common.noUpcomingShows
                    })
                ]
            });
        });
        _this.state = {
            showLoader: true,
            isDataLoaded: false
        };
        _this.renderChannelLogo = _this.renderChannelLogo.bind(_assert_this_initialized(_this));
        _this.renderHistorySliders = _this.renderHistorySliders.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(ChannelHistory, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_props, _$getChannelHistory, match, _$setCurrentChannel, _$getLiveChannels, liveChannels, channelId, channel;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_props = _this.props, _$getChannelHistory = _this_props.getChannelHistory, match = _this_props.match, _$setCurrentChannel = _this_props.setCurrentChannel, _$getLiveChannels = _this_props.getLiveChannels;
                                liveChannels = _this.props.liveChannels;
                                channelId = match.params.channel;
                                if (!isEmpty(liveChannels)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _$getLiveChannels()
                                ];
                            case 1:
                                _state.sent();
                                liveChannels = _this.props.liveChannels;
                                _state.label = 2;
                            case 2:
                                channel = liveChannels[channelId];
                                if (channel) {
                                    _$setCurrentChannel({
                                        channel: channel,
                                        linkIsShown: true
                                    });
                                    _$getChannelHistory(channelId);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState, prevContext) {
                var _this_props = this.props, currentChannel = _this_props.currentChannel, liveChannels = _this_props.liveChannels, _$getChannelHistory = _this_props.getChannelHistory, match = _this_props.match, _$setCurrentChannel = _this_props.setCurrentChannel;
                var channelId = match.params.channel;
                var channelGetsAvailable = !prevProps.liveChannels[channelId] && liveChannels[channelId];
                var hasChannelSwitched = prevProps.match.params.channel !== this.props.match.params.channel;
                if (!this.state.showLoader && (channelGetsAvailable || hasChannelSwitched)) {
                    this.setState({
                        showLoader: true
                    });
                    _$setCurrentChannel({
                        channel: liveChannels[channelId],
                        linkIsShown: true
                    });
                    _$getChannelHistory(channelId);
                }
                var isDataLoaded = this.state.showLoader && Object.keys(currentChannel).length > 0 && Object.keys(liveChannels).length > 0;
                if (isDataLoaded && !this.state.isDataLoaded) {
                    this.setState({
                        isDataLoaded: true
                    });
                }
            }
        },
        {
            key: "renderChannelLogo",
            value: function renderChannelLogo() {
                var _this_props = this.props, match = _this_props.match, logos = _this_props.logos;
                var channelId = match.params.channel;
                var template = null;
                if (logos[channelId]) {
                    template = /*#__PURE__*/ _jsx(ChannelLogo, {
                        hasName: false,
                        channelLogo: logos[channelId],
                        isCentered: false
                    });
                }
                return template;
            }
        },
        {
            key: "renderHistorySliders",
            value: function renderHistorySliders() {
                var _this_props = this.props, currentChannel = _this_props.currentChannel, history = _this_props.history, i18n = _this_props.i18n, logos = _this_props.logos;
                var currentDate = getToday();
                var currentTimestamp = currentDate.getTime();
                var todayCurrentTimestamp = new Date().getTime();
                var template = null;
                var isTomorrowEpgsRequestPending = currentChannel.epgs.isTomorrowEpgsRequestPending || typeof currentChannel.epgs.isTomorrowEpgsRequestPending === "undefined";
                if (Object.keys(currentChannel.epgs).length > 0 || isTomorrowEpgsRequestPending) {
                    template = [];
                }
                while(currentChannel.epgs[currentTimestamp] && currentChannel.epgs[currentTimestamp].length > 0){
                    var shows = _to_consumable_array(currentChannel.epgs[currentTimestamp]).filter(function(show) {
                        return secondsToMilliseconds(show.stop) < todayCurrentTimestamp;
                    });
                    template.push(/*#__PURE__*/ _jsx(ShowsSlider, {
                        infinite: false,
                        channelsLogos: logos,
                        shows: shows,
                        history: history,
                        i18n: i18n,
                        hasLogo: false,
                        hasTitle: true,
                        category: {
                            id: currentTimestamp
                        },
                        channel: currentChannel.channel,
                        hasTitleByDate: true,
                        showCategories: true,
                        timestamp: currentTimestamp,
                        currentDate: new Date(currentTimestamp),
                        level: LIST_LEVEL_ONE,
                        responsiveKey: SLIDER_BIG,
                        isCardBig: true,
                        isCardWithoutHeader: true
                    }, currentTimestamp));
                    currentDate = new Date(currentDate.setDate(currentDate.getDate() - 1));
                    currentTimestamp = currentDate.getTime();
                }
                return template || isTomorrowEpgsRequestPending ? template.length > 0 ? template : null : /*#__PURE__*/ _jsx("div", {
                    className: "no-shows-container",
                    children: i18n.common.noArchieveShows
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, currentChannel = _this_props.currentChannel, i18n = _this_props.i18n, screenType = _this_props.screenType;
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ReactTooltip, {
                            id: "show-slider-tooltip",
                            className: "tooltip",
                            delayShow: TOOLTIP_SHOW_DELAY,
                            place: "bottom",
                            disable: !screenType.web,
                            effect: "solid"
                        }),
                        /*#__PURE__*/ _jsx(LoadProgressBar, {
                            items: [
                                currentChannel.epgs
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "current-channel-container",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "listing-container margin-bottom-med",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "channel-logo-container margin-top-med",
                                        children: this.renderChannelLogo()
                                    }),
                                    this.state.showLoader && !this.state.isDataLoaded ? /*#__PURE__*/ _jsx("div", {
                                        className: "channel-loader-wrapper",
                                        children: /*#__PURE__*/ _jsx(CircularProgress, {
                                            className: "channel-loader"
                                        })
                                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            this.renderUpcomingSlider(),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "archive-container",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "archive-title",
                                                        children: replaceWith(i18n.common.archiveOf, currentChannel.channel.name)
                                                    }),
                                                    this.renderHistorySliders()
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return ChannelHistory;
}(PureComponent);
var mapStateToProps = function(param) {
    var currentChannel = param.currentChannel, liveChannels = param.liveChannels, logos = param.logos, screenType = param.screenType;
    return {
        currentChannel: currentChannel,
        liveChannels: liveChannels,
        logos: logos,
        screenType: screenType
    };
};
var Protected = protect(connect(mapStateToProps, {
    getChannelHistory: getChannelHistory,
    setCurrentChannel: setCurrentChannel,
    getLiveChannels: getLiveChannels
})(ChannelHistory));
export default withParentalLock(Protected);
